export function useApplyRootStyles(styles: Record<string, string | null>) {
  const $root = document.querySelector(':root');

  if ($root === null) {
    throw new Error('Could not find the :root element');
  }

  if (! ($root instanceof HTMLElement)) {
    throw new Error('The :root element is not an HTMLElement');
  }

  for (const key in styles) {
    const value = styles[key];

    if (value !== null) {
      $root.style.setProperty(key, value);
    }
  }
}
